import { render, staticRenderFns } from "./LogViewForm.vue?vue&type=template&id=0d615444"
import script from "./LogViewForm.vue?vue&type=script&lang=js"
export * from "./LogViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports